var map = {
	"./QR.svg": 1354,
	"./arrow-right.svg": 9853,
	"./business.svg": 6450,
	"./caret-down-blue.svg": 8522,
	"./caret-down.svg": 6853,
	"./check.svg": 2325,
	"./checkmark.svg": 7699,
	"./chevron-up.svg": 4966,
	"./code.svg": 1759,
	"./copy.svg": 4017,
	"./document-white.svg": 711,
	"./document.svg": 2441,
	"./en.svg": 1870,
	"./external-link.svg": 6411,
	"./fb.svg": 5897,
	"./feedback.svg": 5039,
	"./gitlab.svg": 9151,
	"./guide-search.svg": 7809,
	"./info.svg": 8873,
	"./list.svg": 2217,
	"./menu-caret.svg": 7422,
	"./message.svg": 4110,
	"./moon.svg": 3575,
	"./note.svg": 4920,
	"./payment.svg": 2214,
	"./payout.svg": 9406,
	"./print.svg": 3413,
	"./refund.svg": 8508,
	"./request.svg": 5511,
	"./search.svg": 1904,
	"./sun.svg": 5222,
	"./sv.svg": 9547,
	"./swish-minimal.svg": 5060,
	"./thumb-down-filled.svg": 5785,
	"./thumb-down-outlined.svg": 5292,
	"./thumb-up-filled.svg": 7852,
	"./thumb-up-outlined.svg": 7762,
	"./times.svg": 7721,
	"./ul-checkmark.svg": 2949,
	"./warning.svg": 8657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3206;